import { render, staticRenderFns } from "./ModalEditName.vue?vue&type=template&id=2ebaa3f0&scoped=true&lang=true&"
import script from "./ModalEditName.vue?vue&type=script&lang=js&"
export * from "./ModalEditName.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditName.vue?vue&type=style&index=0&id=2ebaa3f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaa3f0",
  null
  
)

export default component.exports